import { jsx as e, jsxs as r } from "react/jsx-runtime";

import { createPortal as n } from "react-dom";

import t from "../../utils/classNames/index.js";

import a from "@ui-components-3/icons/lib/duotone/Spinner";

const i = ({className: n, children: i, ...o}) => r("div", {
    ...o,
    className: t("p-s gap-xs inline-grid auto-rows-min place-items-center", n),
    children: [ e(a, {
        "aria-hidden": "true",
        className: "h-m w-m animate-spin"
    }), i ]
}), o = ({portal: r = !0, ...t}) => {
    const a = e("div", {
        className: "bg-neutral/70 fixed inset-0 z-50 grid place-items-center text-white",
        children: e(i, {
            ...t
        })
    });
    return r ? n(a, document.body) : a;
}, s = ({portal: r = !0, ...t}) => {
    const a = e("div", {
        className: "h-xxs bg-primary-300 pointer-events-none fixed top-0 w-full appearance-none overflow-hidden",
        ...t,
        children: e("div", {
            className: "bg-primary-600 animate-loading absolute inset-y-0 w-1/2"
        })
    });
    return r ? n(a, document.body) : a;
}, l = ({variant: r = "normal", portal: n, shown: t = !0, children: a, ...l}) => {
    if (!t) return null;
    switch (r) {
      case "normal":
        return e(i, {
            ...l,
            children: a
        });

      case "big":
        return e(o, {
            portal: n,
            ...l,
            children: a
        });

      default:
        return e(s, {
            portal: n,
            ...l
        });
    }
};

export { l as default };
//# sourceMappingURL=index.js.map
